import React from "react";
import { Container, Card, Badge } from "react-bootstrap";

const TermsComponent = () => {
	return (
		<Container>
			<h1 className="text-start mt-4 mb-4 text-info fw-bold">
				TERMS AND CONDITIONS
			</h1>

			<Card className="shadow mb-4 bg-dark text-white">
				<Card.Body>
					<Card.Text className="mb-4">
						Please carefully read these Terms of Use for The Race Companion, as
						they affect your legal rights and obligations for use.
					</Card.Text>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Agreement
						</Badge>
						Terms of Use
					</Card.Title>

					<div className="mb-4">
						<p>
							The Race Companion, part of TRC Media House, operates the Website
							that links to these Terms of Use. We offer you access to our
							Website and related apps, along with the ability to participate in
							our contests, content, products, services, and promotions
							(collectively the "Services") that we may provide from our Website
							or related apps, subject to these Terms of Use (the "Terms of
							Use", or "Terms"), our privacy policy (the "Privacy Policy") and
							the Official Rules and Regulations for the applicable contests and
							promotions (the "Rules" or "Rules and Scoring," and together with
							the Terms of Use and the Privacy Policy, the "Agreements"). By
							using The Race Companion and its services, you agree to these
							Terms of Use. By accessing this website we assume you accept these
							terms and conditions. Do not continue to use The Race Companion if
							you do not agree to take all of the terms and conditions stated on
							this page.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Eligibility
						</Badge>
						User Requirements
					</Card.Title>

					<div className="mb-4">
						<p>
							You must be at least eighteen (18) years of age or older to create
							an account, participate in contests, and win prizes offered by The
							Race Companion. The Race Companion is not affiliated with or
							sponsored by the Union Cycliste Internationale (UCI).
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Prizes
						</Badge>
						Contest Rewards
					</Card.Title>

					<div className="mb-4">
						<h5 className="text-info">International Winners</h5>
						<p>
							The Race Companion will do its utmost to ship prizes
							Internationally as efficiently as possible within 14 days of the
							events completion. This does not apply to the overall grand prize
							due to production time. The Race Companion will liaise with the
							winner to arrange shipping and delivery of the prize.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Participation
						</Badge>
						Conditions of Participation
					</Card.Title>

					<div className="mb-4">
						<h5 className="text-info">Registration</h5>
						<p>
							By registering as a user of The Race Companion and creating your
							account, you agree to provide accurate and complete information
							about yourself as prompted by the service. By providing inaccurate
							information, The Race Companion reserves the right to deny you the
							ability to participate in its services.
						</p>

						<h5 className="text-info">Account and Security</h5>
						<p>
							You are responsible for creating and remembering a secure password
							for your account. Furthermore, you are responsible for the uses of
							your username and password. Max 2 accounts. Merging of accounts is
							up to the discretion of site administrators and must not be used
							to create an unfair advantage in the game. Merging accounts where
							event results will be overridden will not be allowed (as to not
							use multiple accounts and combine the better scores from each).
						</p>

						<h5 className="text-info">Disqualification</h5>
						<p>
							The Race Companion reserves the right to cancel contests at any
							time without restrictions. The Race Companion may disqualify you
							at any time if it is found, in good faith, that you are to be in
							violation of these Terms of Use or participating in ways to give
							yourself an unfair or fraudulent advantage. To summarise, don't be
							a dick. Examples of actions that could result in disqualification
							from contests and/or termination of your account include, but are
							not limited to: accumulating points through unauthorized methods
							such as bots and/or scripts, false personal information (including
							payment information), tampering with administration services of
							The Race Companion or any of the services required to operate The
							Race Companion service, spam. If The Race Companion services are
							not operating normally due to unauthorized intervention, The Race
							Companion reserves the right to disqualify any and all individuals
							implicated in the cause of abnormal operations, and in some cases
							may result in legal action.
						</p>
					</div>

					{/* Continue with other sections similarly */}
					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Cookies
						</Badge>
						Website Functionality
					</Card.Title>

					<div className="mb-4">
						<p>
							We employ the use of cookies. By accessing The Race Companion, you
							agreed to use cookies in agreement with the TRC Media House's
							Privacy Policy. Most interactive websites use cookies to let us
							retrieve the user's details for each visit. Cookies are used by
							our website to enable the functionality of certain areas to make
							it easier for people visiting our website. Some of our
							affiliate/advertising partners may also use cookies.
						</p>
					</div>

					{/* Add other sections following the same pattern */}
					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Payment
						</Badge>
						Financial Transactions
					</Card.Title>

					<div className="mb-4">
						<p>
							By providing payment information to enter paid contests, you agree
							to provide a valid mailing address, date of birth, and any other
							information we may require in order to verify your eligibility.
							Currently, this is not a service offered by The Race Companion.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Gameplay
						</Badge>
						A Game of Skill & Strategy
					</Card.Title>

					<div className="mb-4">
						<p>
							The Race Companion is a game of skill and strategy, not luck.
							Points are accumulated according to the rules set by The Race
							Companion and its relevant services. The Race Companion is not to
							be considered gambling as it does not rely on luck for success.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Behavior
						</Badge>
						User Conduct
					</Card.Title>

					<div className="mb-4">
						<p>
							As a condition of use, you agree not to use The Race Companion for
							any purpose that is unlawful or is not in accordance with these
							Terms of Use. Examples of improper conduct and use of The Race
							Companion services include, but are not limited to: abuse,
							harassment, impersonation, intimidation or threatening of other
							users, submission or transportation of material that could
							infringe upon normal operation of The Race Companion services,
							submission or transportation of pornographic, offensive,
							defamatory or obscene material, submission of affiliate programs,
							selling your account for any reason. Violation of these rules, or
							any action that could be considered harmful to The Race Companion
							and its services or users, may result in the termination of your
							account and eligibility for any prizes.
						</p>
					</div>

					{/* Continue with remaining sections */}
				</Card.Body>
			</Card>
		</Container>
	);
};

export default TermsComponent;
